<!-- 创建商品 -->
<template>
	<div class="bg-white px-3 goods_create" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;overflow-y: scroll;height: 90vh;">
		<router-link :to="{ name: 'khgl_khgl_khxx' }" style="position: absolute;top: 32px;left: 200px;"><el-button
				size="mini">回到客户列表</el-button></router-link>
		
		<div class="d-flex">
			<div style="width: 12%;">
				<el-menu default-active="1" class="el-menu-vertical-demo">
					<el-menu-item index="1" @click="geta(1)">
						<i class="el-icon-menu"></i>
						<span slot="title">客户信息</span>
					</el-menu-item>
					<el-menu-item index="2" @click="geta(2)">
						<i class="el-icon-document"></i>
						<span slot="title">销售线索</span>
					</el-menu-item>
					<el-menu-item index="3" @click="geta(3)">
						<i class="el-icon-setting"></i>
						<span slot="title">拜访记录</span>
					</el-menu-item>
					<el-menu-item index="4" @click="geta(4)">
						<i class="el-icon-setting"></i>
						<span slot="title">商机记录</span>
					</el-menu-item>
					<el-menu-item index="5" @click="geta(5)">
						<i class="el-icon-setting"></i>
						<span slot="title">联系人</span>
					</el-menu-item>
				</el-menu>
			</div>
			<div style="width: 88%;">
				<div v-if="ins == 1">
					<el-form ref="form" label-width="80px" style="margin-left: 20px;">
						<div class="d-flex pt-a">
							<div style="width: 35%;">
								<el-form-item label="客户名称"><el-input v-model="lists.name" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<el-form-item label="身份证"><el-input v-model="lists.sfz" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<el-form-item label="信息地址"><el-input v-model="lists.city" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<!-- <el-form-item label="责任人">
									<el-button type="success" size="mini">{{ lists.zrr }}</el-button>
								</el-form-item>
								<el-form-item label="释放人">
									<el-button type="success" v-if="!lists.sfr" size="mini">无</el-button>
									<el-button type="success" v-else size="mini">{{ lists.sfr }}</el-button>
								</el-form-item>
								<el-form-item label="释放时间"><el-input v-model="lists.xsgx" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item> -->
							</div>
							<div style="width: 33%;">
								<el-form-item label="客户简称"><el-input v-model="lists.j_name" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<el-form-item label="备注"><el-input v-model="lists.desc" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<el-form-item label="档口地址"><el-input v-model="lists.dkcity" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<!-- <el-form-item label="详细地址"><el-input v-model="lists.xxdz" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<el-form-item label="共享商务">
									<el-button type="success" size="mini">{{ lists.gx }}</el-button>
								</el-form-item>
								<el-form-item label="创建人">
									<el-button type="success" size="mini">{{ lists.cjr }}</el-button>
								</el-form-item>
								<el-form-item label="创建时间"><el-input v-model="lists.create_time" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item> -->
							</div>
							<div style="width: 33%;">
								<el-form-item label="联系电话"><el-input v-model="lists.phone" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<!-- <el-form-item label="电子邮件"><el-input v-model="lists.email" style="width: 90%;" :disabled="true" size="mini"></el-input></el-form-item>
								<el-form-item label="客户状态">
									<el-button type="info" v-if="lists.khzt == 0" size="mini">待开发</el-button>
									<el-button type="success" v-else-if="lists.khzt == 1" size="mini">潜在客户</el-button>
									<el-button type="danger" v-else-if="lists.khzt == 2" size="mini">过期客户</el-button>
									<el-button type="danger" v-else-if="lists.khzt == 3" size="mini">问题客户</el-button>
									<el-button type="primary" v-else size="mini">已成交</el-button>
								</el-form-item> -->
							</div>
						</div>
					</el-form>
				</div>
				<div v-if="ins == 2" class="d-flex">
					<div style="width: 70%;border: 0.5px solid rgb(204, 204, 204,0.5);" :style="{ height: maxHeight }" class="m-2">
						<div class="m-3">销售线索记录</div>
						<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
						<el-table :data="xsxslist" style="width: 100%" size="mini">
							<el-table-column align="center" prop="id" label="编号" width="50"></el-table-column>
							<el-table-column align="center" prop="cjr.name" width="80" label="提交人"></el-table-column>
							<el-table-column prop="tjnr" label="提交内容"></el-table-column>
							<el-table-column align="center" label="上传图片" width="180">
								<template slot-scope="scope">
									<img :src="scope.row.sctp" style="width: 30px;height: 30px;">
								</template>
							</el-table-column>
							<el-table-column align="center" label="提交时间" width="180">
								<template slot-scope="scope">
									{{ scope.row.create_time.slice(0, 10) }}
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div style="width: 30%;border: 0.5px solid rgb(204, 204, 204,0.5);" class="m-2">
						<div class="m-3">添加销售线索</div>
						<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
						<div>
							<el-form ref="form" label-width="80px" style="margin-left: 20px;">
								<el-form-item label="* 线索内容"><el-input v-model="xsxsdata.tjnr" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="上传图片">
									<div>
										<span v-if="!xsxsdata.sctp" class="btn btn-light border mr-2" @click="chooseImage"><i class="el-icon-upload"></i></span>
										<img v-else :src="xsxsdata.sctp" class="rounded" style="width: 45px;height: 45px;cursor: pointer;" @click="chooseImage" />
									</div>
								</el-form-item>
							</el-form>
						</div>
						<div class="d-flex m-2" style="align-items: center;justify-content: center;">
							<el-button type="primary" size="mini" @click="onSubmit">确认提交</el-button>
						</div>
					</div>
				</div>
				<div v-if="ins == 3" class="d-flex">
					<div style="width: 70%;border: 0.5px solid rgb(204, 204, 204,0.5);" :style="{ height: maxHeight }" class="m-2">
						<div class="m-3">拜访记录</div>
						<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
						<el-table :data="bfjllist" style="width: 100%" size="mini">
							<el-table-column align="center" prop="id" label="编号" width="50"></el-table-column>
							<el-table-column align="center" prop="cjr.name" width="80" label="提交人"></el-table-column>
							<el-table-column prop="zysy" label="主要事宜"></el-table-column>
							<el-table-column prop="bfdd" label="拜访地点"></el-table-column>
							<el-table-column align="center" label="上传图片" width="180">
								<template slot-scope="scope">
									<img :src="scope.row.sctp" style="width: 30px;height: 30px;">
								</template>
							</el-table-column>
							<el-table-column align="center" label="提交时间" width="180">
								<template slot-scope="scope">
									{{ scope.row.create_time.slice(0, 10) }}
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div style="width: 30%;border: 0.5px solid rgb(204, 204, 204,0.5);" class="m-2">
						<div class="m-3">添加拜访记录</div>
						<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
						<div>
							<el-form ref="form" label-width="80px" style="margin-left: 20px;">
								<el-form-item label="* 主要事宜"><el-input v-model="bfjldata.zysy" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="拜访地点"><el-input v-model="bfjldata.bfdd" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="上传图片">
									<div>
										<span v-if="!bfjldata.sctp" class="btn btn-light border mr-2" @click="chooseImagea"><i class="el-icon-upload"></i></span>
										<img v-else :src="bfjldata.sctp" class="rounded" style="width: 45px;height: 45px;cursor: pointer;" @click="chooseImagea" />
									</div>
								</el-form-item>
							</el-form>
						</div>
						<div class="d-flex m-2" style="align-items: center;justify-content: center;">
							<el-button type="primary" size="mini" @click="onSubmita">确认提交</el-button>
						</div>
					</div>
				</div>
				<div v-if="ins == 4" class="d-flex">
					<div style="width: 70%;border: 0.5px solid rgb(204, 204, 204,0.5);" :style="{ height: maxHeight }" class="m-2">
						<div class="m-3">商机记录</div>
						<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
						<el-table :data="sjjllist" style="width: 100%" size="mini">
							<el-table-column align="center" prop="id" label="编号" width="50"></el-table-column>
							<el-table-column align="center" prop="cjr.name" width="80" label="提交人"></el-table-column>
							<el-table-column prop="sjnr" label="商机内容" width="140"></el-table-column>
							<el-table-column prop="sjjd.mc" label="商机阶段" width="120" align="center"></el-table-column>
							<el-table-column prop="sjlb.mc" label="商机类别" align="center"></el-table-column>
							<el-table-column prop="xxe" label="销售额" align="center"></el-table-column>
							<el-table-column align="center" label="上传图片" width="80">
								<template slot-scope="scope">
									<img :src="scope.row.sctp" style="width: 30px;height: 30px;">
								</template>
							</el-table-column>
							<el-table-column align="center" label="提交时间" width="130">
								<template slot-scope="scope">
									{{ scope.row.create_time.slice(0, 10) }}
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div style="width: 30%;border: 0.5px solid rgb(204, 204, 204,0.5);" class="m-2">
						<div class="m-3">添加商机记录</div>
						<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
						<div>
							<el-form ref="form" label-width="80px" style="margin-left: 20px;">
								<el-form-item label="* 商机内容"><el-input v-model="sjjldata.sjnr" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="销售额"><el-input-number v-model="sjjldata.xxe" @change="handleChange" size="mini"></el-input-number></el-form-item>
								<el-form-item label="* 商机阶段">
									<el-select v-model="sjjldata.sjjd" placeholder="请选择" size="mini">
									    <el-option
									      v-for="item in sjjd"
									      :key="item.id"
									      :label="item.mc"
									      :value="item.id">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="* 商机类别">
									<el-select v-model="sjjldata.sjlb" placeholder="请选择" size="mini">
									    <el-option
									      v-for="item in sjlb"
									      :key="item.id"
									      :label="item.mc"
									      :value="item.id">
									    </el-option>
									  </el-select>
								</el-form-item>
								<el-form-item label="上传图片">
									<div>
										<span v-if="!sjjldata.sctp" class="btn btn-light border mr-2" @click="chooseImageb"><i class="el-icon-upload"></i></span>
										<img v-else :src="sjjldata.sctp" class="rounded" style="width: 45px;height: 45px;cursor: pointer;" @click="chooseImageb" />
									</div>
								</el-form-item>
							</el-form>
						</div>
						<div class="d-flex m-2" style="align-items: center;justify-content: center;">
							<el-button type="primary" size="mini" @click="onSubmitb">确认提交</el-button>
						</div>
					</div>
				</div>
				<div v-if="ins == 5" class="d-flex">
					<div style="width: 70%;border: 0.5px solid rgb(204, 204, 204,0.5);" :style="{ height: maxHeight }" class="m-2">
						<div class="m-3">联系人</div>
						<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
						<el-table :data="lxrlist" style="width: 100%" size="mini">
							<el-table-column align="center" prop="id" label="编号" width="50"></el-table-column>
							<el-table-column align="center" prop="cjr.name" width="80" label="提交人"></el-table-column>
							<el-table-column prop="mc" label="姓名"></el-table-column>
							<el-table-column prop="sjh" label="手机号" width="120"></el-table-column>
							<el-table-column prop="gh" label="固话" width="120"></el-table-column>
							<el-table-column prop="wxh" label="微信号" width="120"></el-table-column>
							<el-table-column prop="yx" label="邮箱" width="150"></el-table-column>
							<el-table-column prop="desc" label="备注"></el-table-column>
							<el-table-column align="center" label="提交时间" width="130">
								<template slot-scope="scope">
									{{ scope.row.create_time.slice(0, 10) }}
								</template>
							</el-table-column>
						</el-table>
					</div>
					<div style="width: 30%;border: 0.5px solid rgb(204, 204, 204,0.5);" class="m-2">
						<div class="m-3">添加联系人</div>
						<div style="width: 100%;background: rgb(204, 204, 204,0.5);height: 0.5px;"></div>
						<div>
							<el-form ref="form" label-width="80px" style="margin-left: 20px;">
								<el-form-item label="* 姓名"><el-input v-model="lxrdata.mc" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="手机号"><el-input v-model="lxrdata.sjh" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="固话"><el-input v-model="lxrdata.gh" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="微信号"><el-input v-model="lxrdata.wxh" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="邮箱"><el-input v-model="lxrdata.yx" style="width: 90%;" size="mini"></el-input></el-form-item>
								<el-form-item label="备注"><el-input v-model="lxrdata.desc" style="width: 90%;" size="mini"></el-input></el-form-item>
							</el-form>
						</div>
						<div class="d-flex m-2" style="align-items: center;justify-content: center;">
							<el-button type="primary" size="mini" @click="onSubmitc">确认提交</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 250px;right: 0;z-index: 100;justify-content: center;">
			<router-link :to="{ name: 'khgl_khgl_khxx' }"><el-button type="info">关闭窗口</el-button></router-link>
		</el-footer>
	</div>
</template>

<script>
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	inject: ['app', 'layout'],
	data() {
		return {
			lists: {},
			ins: 1,
			maxHeight: 0,
			sjlb: [],
			sjjd: [],
			xsxslist: [],
			bfjllist: [],
			sjjllist:[],
			lxrlist:[],
			xsxsdata:{
				tjnr:'',
				sctp:''
			},
			sjjldata:{
				tjnr:'',
				sctp:''
			},
			bfjldata:{
				zysy:'',
				bfdd:'',
				sctp:''
			},
			lxrdata:{
				mc:'',
				sjh:'',
				gh:'',
				wxh:'',
				yx:'',
				desc:''
			},
			options: [
				{
					value: 0,
					label: '待开发'
				},
				{
					value: 1,
					label: '潜在客户'
				},
				{
					value: 2,
					label: '过期客户'
				},
				{
					value: 3,
					label: '问题客户'
				},
				{
					value: 4,
					label: '已成交'
				}
			]
		};
	},
	computed: {
		...mapState({
			user: state => state.user.user
		})
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 274; //300是页面中除了表格外其他组件的高度
		});
	},
	// 生命周期
	created() {
		this.lists = this.$route.params.data;
		this.xslist()
		this.bflist()
		this.sjlist()
		this.lxlist()
		this.axios.get('/admin/khlba/list', { token: true }).then(res => {
			this.sjjd = res.data.data;
		});
		this.axios.get('/admin/khlbb/list', { token: true }).then(res => {
			this.sjlb = res.data.data;
		});
	},
	methods: {
		xslist(){
			this.axios.get('/admin/khxss/' + this.lists.id, { token: true }).then(res => {
				this.xsxslist = res.data.data;
			});
		},
		bflist(){
			this.axios.get('/admin/khbfs/' + this.lists.id, { token: true }).then(res => {
				this.bfjllist = res.data.data;
			});
		},
		sjlist(){
			this.axios.get('/admin/khsjs/' + this.lists.id, { token: true }).then(res => {
				this.sjjllist = res.data.data;
			});
		},
		lxlist(){
			this.axios.get('/admin/khlxrs/' + this.lists.id, { token: true }).then(res => {
				this.lxrlist = res.data.data;
			});
		},
		onSubmit(){
			let e = {
				cjr:this.user.id,
				tjnr:this.xsxsdata.tjnr,
				sctp:this.xsxsdata.sctp ? this.xsxsdata.sctp : '',
				khid:this.lists.id
			}
			this.axios.post('/admin/khxs', e, {token: true})
				.then(res => {
					this.$message({
						type: 'success',
						message: '提交成功'
					});
					this.xslist()
					let x = {
						tjnr:'',
						sctp:''
					}
					this.xsxsdata = x
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		},
		onSubmita(){
			let e = {
				cjr:this.user.id,
				zysy:this.bfjldata.zysy,
				bfdd:this.bfjldata.bfdd,
				sctp:this.bfjldata.sctp ? this.bfjldata.sctp : '',
				khid:this.lists.id
			}
			this.axios.post('/admin/khbf', e, {token: true})
				.then(res => {
					this.$message({
						type: 'success',
						message: '提交成功'
					});
					this.bflist()
					let x = {
						zysy:'',
						bfdd:'',
						sctp:''
					}
					this.bfjldata = x
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		},
		onSubmitb(){
			let e = {
				cjr:this.user.id,
				sjnr:this.sjjldata.sjnr,
				xxe:this.sjjldata.xxe,
				sjjd:this.sjjldata.sjjd,
				sjlb:this.sjjldata.sjlb,
				sctp:this.sjjldata.sctp ? this.sjjldata.sctp : '',
				khid:this.lists.id
			}
			this.axios.post('/admin/khsj', e, {token: true})
				.then(res => {
					this.$message({
						type: 'success',
						message: '提交成功'
					});
					this.sjlist()
					let x = {
						sjnr:'',
						xxe:'',
						sjjd:'',
						sjlb:'',
						sctp:''
					}
					this.sjjldata = x
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		},
		onSubmitc(){
			let e = {
				cjr:this.user.id,
				mc:this.lxrdata.mc,
				sjh:this.lxrdata.sjh,
				gh:this.lxrdata.gh,
				wxh:this.lxrdata.wxh,
				yx:this.lxrdata.yx,
				desc:this.lxrdata.desc,
				khid:this.lists.id
			}
			this.axios.post('/admin/khlxr', e, {token: true})
				.then(res => {
					this.$message({
						type: 'success',
						message: '提交成功'
					});
					this.lxlist()
					let x = {
						mc:'',
						sjh:'',
						gh:'',
						wxh:'',
						yx:'',
						desc:''
					}
					this.lxrdata = x
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		},
		chooseImage() {
			this.app.chooseImage(res => {
				this.xsxsdata.sctp = res[0].url;
			}, 1);
		},
		chooseImagea() {
			this.app.chooseImage(res => {
				this.bfjldata.sctp = res[0].url;
			}, 1);
		},
		chooseImageb() {
			this.app.chooseImage(res => {
				this.sjjldata.sctp = res[0].url;
			}, 1);
		},
		geta(e) {
			this.ins = e;
		},
		//提交
		submit() {
			this.layout.showLoading();
			console.log(this.lists);
			if (!this.lists.id) {
				this.lists.cjr = this.user.id;
			}
			let url = this.lists.id ? '/admin/khxx/' + this.lists.id : '/admin/khxx';
			this.axios.post(url, this.lists, {token: true})
				.then(res => {
					this.$message({
						type: 'success',
						message: this.id ? '修改成功' : '添加成功'
					});
					this.$router.push({
						name: 'khgl_khgl_khxx'
					});
					this.layout.hideLoading();
				})
				.catch(err => {
					this.layout.hideLoading();
				});
		},
		handleChange(value) {
		      }
	}
};
</script>

<style>
.goods_create .el-form-item {
	margin-bottom: 15px;
}
.pt-a {
	padding-top: 20px;
}
</style>
